module.exports = __webpack_public_path__ + "img/2.de8dd3ae.png";